"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { TextField } from "@mui/material";

// Visual reference: (digital_profile)/digital-profile/_components/DpComponents/ConnectField.js
// Kept as a local copy (not an import) so this route stays decoupled from the
// digital-profile tree; styling intentionally mirrors it.
const GetInTouchField = t0 => {
  const $ = _c(60);
  const {
    label,
    name,
    value,
    onChange,
    icon: Icon,
    onFieldClick,
    onBlur,
    error: t1,
    errorMessage: t2,
    placeholder: t3,
    readOnly: t4,
    multiline: t5,
    helperText: t6,
    valueTitle: t7
  } = t0;
  const error = t1 === undefined ? false : t1;
  const errorMessage = t2 === undefined ? null : t2;
  const placeholder = t3 === undefined ? "" : t3;
  const readOnly = t4 === undefined ? false : t4;
  const multiline = t5 === undefined ? false : t5;
  const helperText = t6 === undefined ? "" : t6;
  const valueTitle = t7 === undefined ? "" : t7;
  const hasError = error && errorMessage;
  const t8 = `flex gap-3 ${multiline ? "items-center" : "items-end"}`;
  let t9;
  if ($[0] !== Icon) {
    t9 = Icon && <Icon sx={{
      color: "var(--colorSecondarySecondaryContainer, #dee1f9)",
      fontSize: "24px",
      marginBottom: "8px"
    }} />;
    $[0] = Icon;
    $[1] = t9;
  } else {
    t9 = $[1];
  }
  let t10;
  if ($[2] !== hasError || $[3] !== label || $[4] !== valueTitle) {
    t10 = valueTitle && <><span className={`m3-body-small mb-1 ${hasError ? "text-[--textErrorErrorText]" : "text-[--textDisabledDisabled]"}`}>{label}</span><span className="m3-body-large font-bold text-[--textPrimaryPrimary]">{valueTitle}</span></>;
    $[2] = hasError;
    $[3] = label;
    $[4] = valueTitle;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  const t11 = valueTitle ? null : label;
  let t12;
  if ($[6] !== errorMessage || $[7] !== hasError || $[8] !== helperText) {
    t12 = hasError ? errorMessage : helperText ? <span className="m3-body-small text-[--textDisabledDisabled] italic">{helperText}</span> : null;
    $[6] = errorMessage;
    $[7] = hasError;
    $[8] = helperText;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  const t13 = multiline ? 4 : undefined;
  let t14;
  if ($[10] !== readOnly) {
    t14 = {
      readOnly
    };
    $[10] = readOnly;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  let t15;
  let t16;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      className: "m3-body-large"
    };
    t16 = {
      disableUnderline: false
    };
    $[12] = t15;
    $[13] = t16;
  } else {
    t15 = $[12];
    t16 = $[13];
  }
  let t17;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      inputLabel: t15,
      input: t16,
      formHelperText: {
        className: "m3-body-small",
        sx: {
          marginTop: "4px",
          marginLeft: 0,
          color: "var(--textErrorErrorText, #BA1A1A)"
        }
      }
    };
    $[14] = t17;
  } else {
    t17 = $[14];
  }
  const t18 = readOnly ? "pointer" : "text";
  let t19;
  if ($[15] !== multiline) {
    t19 = multiline && {
      whiteSpace: "pre-wrap",
      wordWrap: "break-word",
      overflowWrap: "break-word"
    };
    $[15] = multiline;
    $[16] = t19;
  } else {
    t19 = $[16];
  }
  let t20;
  if ($[17] !== t18 || $[18] !== t19) {
    t20 = {
      paddingBottom: "12px",
      paddingTop: "12px",
      fontSize: "16px",
      color: "var(--textPrimaryPrimary, #1B1C17)",
      cursor: t18,
      ...t19
    };
    $[17] = t18;
    $[18] = t19;
    $[19] = t20;
  } else {
    t20 = $[19];
  }
  let t21;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = {
      cursor: "pointer",
      backgroundColor: "transparent"
    };
    $[20] = t21;
  } else {
    t21 = $[20];
  }
  const t22 = hasError ? "var(--textErrorErrorText, #BA1A1A)" : "var(--textDisabledDisabled, #17191c59)";
  const t23 = hasError ? "var(--textErrorErrorText, #BA1A1A)" : "var(--colorPrimaryPrimary, #004BEE)";
  let t24;
  if ($[21] !== t23) {
    t24 = {
      color: t23
    };
    $[21] = t23;
    $[22] = t24;
  } else {
    t24 = $[22];
  }
  let t25;
  if ($[23] !== t22 || $[24] !== t24) {
    t25 = {
      fontSize: "16px",
      color: t22,
      "&.Mui-focused": t24
    };
    $[23] = t22;
    $[24] = t24;
    $[25] = t25;
  } else {
    t25 = $[25];
  }
  const t26 = hasError ? "3px solid var(--colorErrorError, #BA1A1A) !important" : "1px solid var(--colorOutlineOutline, #AEB7F9) !important";
  let t27;
  if ($[26] !== t26) {
    t27 = {
      borderBottom: t26
    };
    $[26] = t26;
    $[27] = t27;
  } else {
    t27 = $[27];
  }
  const t28 = hasError ? "3px solid var(--colorErrorError, #BA1A1A) !important" : "1px solid var(--colorOutlineOutline, #AEB7F9) !important";
  let t29;
  if ($[28] !== t28) {
    t29 = {
      borderBottom: t28
    };
    $[28] = t28;
    $[29] = t29;
  } else {
    t29 = $[29];
  }
  const t30 = hasError ? "var(--colorErrorError, #BA1A1A) !important" : "var(--colorPrimaryPrimary, #004BEE) !important";
  const t31 = hasError ? "3px !important" : "2px !important";
  let t32;
  if ($[30] !== t30 || $[31] !== t31) {
    t32 = {
      borderBottomColor: t30,
      borderBottomWidth: t31
    };
    $[30] = t30;
    $[31] = t31;
    $[32] = t32;
  } else {
    t32 = $[32];
  }
  let t33;
  if ($[33] !== t20 || $[34] !== t25 || $[35] !== t27 || $[36] !== t29 || $[37] !== t32) {
    t33 = {
      width: "100%",
      flex: 1,
      "& .MuiInputBase-input": t20,
      "& .MuiInputBase-input[readonly]": t21,
      "& .MuiInputLabel-root": t25,
      "& .MuiInput-underline:before": t27,
      "& .MuiInput-underline:hover:before": t29,
      "& .MuiInput-underline:after": t32
    };
    $[33] = t20;
    $[34] = t25;
    $[35] = t27;
    $[36] = t29;
    $[37] = t32;
    $[38] = t33;
  } else {
    t33 = $[38];
  }
  let t34;
  if ($[39] !== hasError || $[40] !== multiline || $[41] !== name || $[42] !== onBlur || $[43] !== onChange || $[44] !== onFieldClick || $[45] !== placeholder || $[46] !== t11 || $[47] !== t12 || $[48] !== t13 || $[49] !== t14 || $[50] !== t33 || $[51] !== value) {
    t34 = <TextField label={t11} name={name} value={value} variant="standard" onChange={onChange} onBlur={onBlur} onClick={onFieldClick} placeholder={placeholder} error={hasError} helperText={t12} multiline={multiline} maxRows={t13} InputProps={t14} slotProps={t17} sx={t33} />;
    $[39] = hasError;
    $[40] = multiline;
    $[41] = name;
    $[42] = onBlur;
    $[43] = onChange;
    $[44] = onFieldClick;
    $[45] = placeholder;
    $[46] = t11;
    $[47] = t12;
    $[48] = t13;
    $[49] = t14;
    $[50] = t33;
    $[51] = value;
    $[52] = t34;
  } else {
    t34 = $[52];
  }
  let t35;
  if ($[53] !== t10 || $[54] !== t34) {
    t35 = <div className="flex flex-1 flex-col">{t10}{t34}</div>;
    $[53] = t10;
    $[54] = t34;
    $[55] = t35;
  } else {
    t35 = $[55];
  }
  let t36;
  if ($[56] !== t35 || $[57] !== t8 || $[58] !== t9) {
    t36 = <div className="flex flex-col gap-1"><div className={t8}>{t9}{t35}</div></div>;
    $[56] = t35;
    $[57] = t8;
    $[58] = t9;
    $[59] = t36;
  } else {
    t36 = $[59];
  }
  return t36;
};
export default GetInTouchField;